import { render, staticRenderFns } from "./StartedOnboarding.vue?vue&type=template&id=48a76f80"
import script from "./StartedOnboarding.vue?vue&type=script&lang=js"
export * from "./StartedOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports